import { Injectable } from '@angular/core';
import { type Observable, of } from 'rxjs';
import { FilterConfigService, type FilterDataResult, SearchFilterModel } from '@ui/shared/util-filter';
import { CultureMapFilterKey } from '../../enums/culture-map-filter-key';

@Injectable({ providedIn: 'root' })
export class SearchFilterConfigService extends FilterConfigService<CultureMapFilterKey, undefined> {
    public override placeholder = 'Name des Kulturangebots, -verein oder der -einrichtung';

    constructor() {
        super(
            new SearchFilterModel(CultureMapFilterKey.TextSearch, 'Suchbegriff', []),
            undefined,
        );
    }

    protected _getOptions$(): Observable<FilterDataResult> {
        return of({ data: [] });
    }
}
